var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border"},[_c('div',{staticStyle:{"padding":"1rem"}},[_c('PageHeader',{attrs:{"title":"รีวิวทั้งหมด"}}),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('review',{attrs:{"apiRoute":`/v1/analytics/courses/getCourseOverviewReview`,"perPage":10,"tab":true}})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }